import * as t from 'io-ts';

import {WithClientId} from '../../settings/editors/commons/clientIdModel';
import {RCompoundConditions} from '../../settings/editors/conditions/compoundConditionModel';
import {makeApiType} from './apiTypes';

/*
 * Runtime types.
 */

const RRequiredTaggingParameter = t.readonly(
  t.type({
    tagListName: t.string,
    isOneTagRequired: t.boolean,
    tagIds: t.readonlyArray(t.Integer),
  }),
);

const RRequiredTagging = t.readonly(
  t.intersection([
    t.type({
      name: t.string,
      conditions: RCompoundConditions,
      requiredTaggingParams: t.readonlyArray(RRequiredTaggingParameter),
    }),
    t.partial({
      id: t.Integer,
    }),
  ]),
);

/*
 * Types.
 */

export interface RequiredTaggingParameterModel extends t.TypeOf<typeof RRequiredTaggingParameter> {}

export type ClientRequiredTaggingParameter = WithClientId<RequiredTaggingParameterModel>;

export interface RequiredTaggingModel extends t.TypeOf<typeof RRequiredTagging> {}

/*
 * Helpers.
 */

function parseRequiredTaggingParameter(src: any): RequiredTaggingParameterModel {
  return {
    tagListName: src.tag_list_name,
    isOneTagRequired: src.one_tag_required,
    tagIds: src.tag_ids,
  };
}

export function parseRequiredTagging(src: any): RequiredTaggingModel {
  return {
    id: src.id,
    name: src.name,
    conditions: src.conditions,
    requiredTaggingParams: src.required_tagging_params.map(parseRequiredTaggingParameter),
  };
}

export function serializeRequiredTagging(src: RequiredTaggingModel): any {
  return {
    name: src.name,
    conditions: src.conditions,
    required_tagging_params: src.requiredTaggingParams.map((requiredTaggingParam) => ({
      tag_list_name: requiredTaggingParam.tagListName,
      one_tag_required: requiredTaggingParam.isOneTagRequired,
      tag_ids: requiredTaggingParam.tagIds,
    })),
  };
}

/*
 * API type.
 */

export const ApiRequiredTagging = makeApiType('requiredTagging', RRequiredTagging, parseRequiredTagging);
